export default __webpack_public_path__ + "static/img/2.3b130db.png";